"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollMarginTop = exports.getOffsetTop = void 0;
const getOffsetTop = element => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
};
exports.getOffsetTop = getOffsetTop;
const getScrollMarginTop = element => {
  let scrollMarginTop = 0;
  while (element) {
    scrollMarginTop += parseInt(window.getComputedStyle(element).scrollMarginTop, 10);
    element = element.offsetParent;
  }
  return scrollMarginTop;
};
exports.getScrollMarginTop = getScrollMarginTop;